import { SpaceBetween } from "@cloudscape-design/components-themed";

import { Main } from "../components/merchants-alternative-direct-application/Main";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

const MerchantAlternativeDirectApplication = () => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.APPLY_MERCHANT_DIRECT);

  return (
    <SpaceBetween size="l">
      <Main />
    </SpaceBetween>
  );
};

export default MerchantAlternativeDirectApplication;
